import {BTCWalletAdapter} from "../WalletAdapter";
import matchlog from "../../utils/matchlog";
import {bytesToBase64} from "../../utils";

export class PhantomAdapter implements BTCWalletAdapter {
    name = "Phantom Wallet";
    website="https://www.phantom.com/"
    walletKey="phantom"

    async isInstalled() {
        return typeof window.phantom !== "undefined" && typeof window.phantom.bitcoin !== "undefined";
    }

    async connect(): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Phantom Wallet is not installed");
        const response = await window.phantom.bitcoin.requestAccounts()
        const ordinalAddress = response.find((n: any) => n.purpose == 'ordinals')

        matchlog.log("Addresses:", ordinalAddress);
        if (!ordinalAddress) {
            throw new Error("No addresses found in Phantom Wallet")
        }

        return ordinalAddress.address
    }

    async signMessage(message: string): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Phantom Wallet is not installed");
        const address = await this.connect()
        try {
            const {signature} =  await window.phantom.bitcoin.signMessage(address, new TextEncoder().encode(message))
            return bytesToBase64(signature)
        } catch (error) {
            console.error(error)
            throw error
        }
    }
}
